import React from "react";
import Button from "../../../../shared/components/button";
import Variant from "../../../../shared/enums/Variant";
import SocialMediaShare from "../../../../shared/components/socialMediaShare";
import CommonApi from "../../../../shared/enums/CommonApi";
import { useRegDetail } from "../../../../shared/context/regDetail";
import { useCopies } from "../../../../shared/hooks/useCopies";
import { ApiRegistrationParticipantForParticipantResponse } from "../../../../shared/types/ApiRegistrationParticipantForParticipantResponse";
import UserAgentUtil from "../../../../shared/utils/useAgent";
import TicketStatus from "../../../../shared/enums/TicketStatus";
import Icon from "assets/icons";

export default function SocialMediaShareHandler({
  participantObj
}: {
  participantObj: ApiRegistrationParticipantForParticipantResponse;
}) {
  const copies = useCopies();
  const { shareOnSocialMediaEnabledForRegistration, socialMediaTemplateText = "" } = useRegDetail();
  const [showSocialMediaShare, setShowSocialMediaShare] = React.useState<boolean>(false);

  const isShareOnSocialMediaApplicable = React.useMemo(() => {
    if (UserAgentUtil.isMobileDevice() || UserAgentUtil.isTabletDevice()) {
      return false;
    }
    return shareOnSocialMediaEnabledForRegistration && participantObj.ticketStatus === TicketStatus.COMPLETED;
  }, [participantObj.ticketStatus, shareOnSocialMediaEnabledForRegistration]);

  return (
    <React.Fragment>
      {isShareOnSocialMediaApplicable && (
        <Button
          variant={Variant.PRIMARY}
          icon={<Icon.SocialShare />}
          label={copies.get("share.on.social.media")}
          isOutline
          onClick={() => {
            setShowSocialMediaShare(true);
          }}
        />
      )}
      {showSocialMediaShare && (
        <SocialMediaShare
          shareText={socialMediaTemplateText}
          listApi={CommonApi.FIND_SOCIAL_TEMPLATES_PUBLIC}
          onClose={() => {
            setShowSocialMediaShare(false);
          }}
          regParticipantId={participantObj.id}
          handleHeadshotUpload={() => {}}
          headshot={""}
          participantData={{
            firstName: participantObj.firstName,
            lastName: participantObj.lastName,
            jobTitle: participantObj.jobTitle,
            organization: participantObj.registrationOrganizationName
          }}
        />
      )}
    </React.Fragment>
  );
}
